import stickElement from '../components/stickit'
import 'jquery-drilldown'
import { getCookie, setCookie } from '../util/cookie'
import $ from 'jquery'

export default {
  init() {
    function smooth_scroll(link, e) {
      if (e) e.preventDefault()
      var hash = false
      if (!link && window.location.hash) {
        hash = window.location.hash
      } else if (link && link.indexOf('#') == 0) {
        hash = link
      } else if (
        link &&
        location.pathname.replace(/^\//, '') ==
          link.pathname.replace(/^\//, '') &&
        location.hostname == link.hostname
      ) {
        hash = link.hash
      }
      if (hash && $(hash).length) {
        $('html, body').animate(
          {
            scrollTop: $(hash).offset().top - 120,
          },
          600
        )
        history.replaceState(null, null, hash)
      }
      $(window).trigger('hashchange')
    }

    function setMobileClass() {
      if ($(window).outerWidth() <= 991) {
        $('body').addClass('mobile')
      } else {
        $('body').removeClass('mobile')
      }
    }

    function gfFieldsScript() {
      // Gravity Form: hide label when input is in focus
      // Handling Gravity Form input labels
      $(
        'input[type=text], input[type=tel], input[type=email], input[type=number], textarea, .ginput_container_select select'
      ).on('keypress focus input', function () {
        if ($(this).val().length > 0) {
          $(this).parents('.gfield').addClass('focused')
          $(this)
            .parents(
              '.dropdown-with-text-input, .input-search, .input-variation'
            )
            .addClass('focused')
        }
      })

      $(
        'input[type=text], input[type=tel], input[type=email], input[type=number], textarea, .ginput_container_select select'
      ).each(function () {
        if ($(this).val().length > 0) {
          $(this).parents('.gfield').addClass('focused')
          $(this)
            .parents(
              '.dropdown-with-text-input, .input-search, .input-variation'
            )
            .addClass('focused')
        }
      })

      $(
        'input[type=text], input[type=tel], input[type=email], input[type=number], textarea, .ginput_container_select select'
      ).on('blur', function () {
        if ($(this).val().length === 0) {
          $(this).parents('.gfield').removeClass('focused')
          $(this)
            .parents(
              '.dropdown-with-text-input, .input-search, .input-variation'
            )
            .removeClass('focused')
        }
      })

      $('#gform_submit_button_4').on('click', function () {
        $(this).addClass('clicked')
      })
    }

    $(document).ready(function () {
      /* eslint-disable */
      $(
        'a[href^="#"]:not([href="#"],[href="#0"],[href^="#fancy-"],[data-toggle],[role="tab"])'
      ).on('click', function (e) {
        smooth_scroll($(this).attr('href'), e)
      })
      /* eslint-enable */
      if (window.location.hash) {
        smooth_scroll(window.location.hash)
      }

      stickElement('.banner .topbar')
      stickElement('.banner .navbar')
      stickElement('.page-anchors')
      stickElement('.privacy-menu')
      // stickElement('.contact-person')
      // stickElement('#page-contents')

      // Gravity Form: Put the Submit button into 'gform_body' container
      $('.gform_column').last().append($('.gform_footer'))

      gfFieldsScript()

      $('.drilldown').drilldown()

      $('.drilldown .menu-item-has-children > a').on('click', function (e) {
        e.preventDefault()
      })

      // Calls the selectBoxIt method for default HTML select box
      $('select:not(.default_select)').SumoSelect()

      //$('.gform_wrapper').addClass('loaded')
    })

    // usercentrics settings modal
    $('a').on('click', function () {
      if ($(this).attr('href').includes('#uc-corner-modal-show')) {
        window.UC_UI.showSecondLayer()
      }
    })

    // Gravity Form: Keep the Submit button into 'gform_body' container after form submitting
    $(document).bind('gform_post_render', function () {
      $('.gform_column').last().append($('.gform_footer'))

      gfFieldsScript()
    })

    /* function resizeFullWidthRow() {
      $('[data-vc-full-width="true"]').each(function() {
        $(this).css({
          width: document.body.clientWidth,
          marginLeft: -document.body.clientWidth / 2,
        })
        if (!$(this).attr('data-vc-stretch-content')) {
          // let padding =
          //   (document.body.clientWidth - $('.container.wrap').outerWidth()) / 2
          // $(this).css({
          //   'padding-left': padding,
          //   'padding-right': padding,
          // })
        }
      })
    }

    resizeFullWidthRow() */

    $(window).on('resize', function () {
      //resizeFullWidthRow()
      setMobileClass()
    })

    // Scroll to top
    // defining elements
    function getScrollWindow() {
      var e = document.documentElement,
        o = document.body,
        t = e.scrollTop || (o && o.scrollTop) || 0
      return (t -= e.clientTop)
    }

    var toTop = $('.to-top')

    $(document).ready(function () {
      // Listening for click event
      $('.to-top').on('click', function (e) {
        e.preventDefault()
        $('html, body').animate(
          {
            scrollTop: 0,
          },
          600
        )
      })
      setMobileClass()
    })

    $(window).on('scroll', function () {
      // Detecting when to show the button
      if (
        getScrollWindow() > $(window).outerHeight() / 2 &&
        !toTop.hasClass('visible')
      ) {
        toTop.addClass('visible')
      } else if (
        getScrollWindow() <= $(window).outerHeight() / 2 &&
        toTop.hasClass('visible')
      ) {
        toTop.removeClass('visible')
      }
    })

    $('.banner [data-toggle="collapse"]').on('click', function () {
      $(this)
        .siblings('[data-toggle="collapse"][aria-expanded="true"]')
        .trigger('click')
    })

    // Menu dropdown on hover
    $('.nav-item.dropdown').on('mouseenter', function () {
      const $this = $(this)
      const $menu = $this.find('> .dropdown-menu')
      if (!$menu.hasClass('show') && !$('body').hasClass('mobile')) {
        $menu.addClass('show')
      }
    })
    $('.nav-item .nav-item:not(.dropdown)').on('mouseenter', function () {
      const $this = $(this)
      const $menu = $this.parent().find('.nav-item.dropdown > .dropdown-menu')
      if ($menu.hasClass('show') && !$('body').hasClass('mobile')) {
        $menu.removeClass('show')
      }
    })
    $('.navbar-nav > .nav-item.dropdown').on('mouseleave', function () {
      const $this = $(this)
      const $menu = $this.find('> .dropdown-menu')
      if ($menu.hasClass('show') && !$('body').hasClass('mobile')) {
        $menu.removeClass('show')
      }
    })
    $(
      '.navbar-nav > .nav-item.dropdown > .dropdown-menu > .nav-item.dropdown'
    ).on('mouseleave', function () {
      const $this = $(this)
      const $menu = $this.find('> .dropdown-menu')
      if ($menu.hasClass('show') && !$('body').hasClass('mobile')) {
        $menu.removeClass('show')
      }
    })
    $('.dropdown-menu').on('mouseleave', function () {
      const $this = $(this)
      $this.removeClass('show')

      $this.find('.dropdown-menu').removeClass('show')
    })
    $('.dropdown-toggle').on('click tap', function () {
      const $this = $(this)
      $this.next().toggleClass('show')
    })

    // DHSV
    browserDetection()
    init_lngBox()
    init_mediabox()
    init_tobaccoDisclaimer()
    init_popupDisclaimer()
    init_toggleSearchbar()
    init_footerDropdowns()
    //init_gform_loaded()

    /*
    function init_gform_loaded() {
      $(document).ready(function() {
        $('.gform_wrapper').addClass('loaded')
      })
    }
    */

    function browserDetection() {
      if (navigator.userAgent.indexOf('Firefox') !== -1) {
        $('body').addClass('firefox')
      }
    }

    function init_lngBox() {
      $('.topbar__languages .lng__head').on('click tap', function () {
        var e = $(this)
        var parent = e.parent()

        if (parent.hasClass('active')) {
          parent.removeClass('active')
        } else {
          parent.addClass('active')
        }
      })

      $(document).on('mouseup touchend', function (e) {
        const $head = $('.topbar__languages .lng__head')
        if (!$head.is(e.target) && $head.has(e.target).length === 0) {
          $head.parent().removeClass('active')
        }
      })

      $('.topbar__languages .lng__body').on('mouseleave', function () {
        const $this = $(this)
        $this.parent().removeClass('active')
      })
    }

    function init_mediabox() {
      const modalbox = $('.fullscreen-modal')
      const modalbox_inner = modalbox.find('.inner')

      $('.dhsv_vc_media .fullscreen').on('click tap', function () {
        let $this = $(this)
        modalbox.fadeIn().addClass('open')
        modalbox_inner.css(
          'background-image',
          'url(' + $this.data('imagesrc') + ')'
        )
      })

      modalbox_inner.find('.icon').on('click tap', function () {
        modalbox.fadeOut().removeClass('open')
      })
    }

    function init_tobaccoDisclaimer() {
      const $disclaimer = $('.disclaimer.-tobacco')
      if ($disclaimer.length > 0) {
        if (getCookie('tobaccoDisclaimerClosed')) {
          $disclaimer.remove()
        } else {
          $disclaimer.removeClass('hidden')

          $disclaimer.find('button').on('click tap', function () {
            $disclaimer.remove()
            setCookie('tobaccoDisclaimerClosed', 1)
          })
        }
      }
    }

    function init_popupDisclaimer() {
      const $disclaimer = $('.disclaimer.-popup')
      if ($disclaimer.length > 0) {
        if (getCookie('popupDisclaimerClosed')) {
          $disclaimer.remove()
        } else {
          $disclaimer.removeClass('hidden')

          $disclaimer.find('button').on('click tap', function () {
            $disclaimer.remove()
            setCookie('popupDisclaimerClosed', 1)
          })
        }
      }
    }

    function init_toggleSearchbar() {
      const $searchbar = $('#searchbar')
      $('.searchbar-toggler').on('click tap', function () {
        $searchbar.toggleClass('open')
      })

      $searchbar.find('i').on('click tap', function () {
        $searchbar.removeClass('open')
      })
    }

    function init_footerDropdowns() {
      $(
        '.footer__main .footer__menu > li.menu-item-has-children > ul > li.menu-item-has-children > a'
      ).on('click tap', function (e) {
        e.preventDefault()
        const $this = $(this)
        //const $li = $this.parent()
        var $menu = $this.next()

        if ($this.hasClass('active')) {
          $menu.animate(
            {
              height: 0,
            },
            400
          )
          $this.removeClass('active')
        } else {
          $menu.animate(
            {
              height: $menu.get(0).scrollHeight,
            },
            400,
            function () {
              $menu.height('auto')
            }
          )
          $this.addClass('active')
        }
      })
    }

    jQuery(document).ready(function ($) {
      $(document).on(
        'click',
        '#gform_20 .gform_page_footer .gform_next_button',
        function (e) {
          e.preventDefault()

          var $form = $(this).closest('form')

          if ($form.attr('id') !== 'gform_20') {
            return
          }

          $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function () {
              if (
                typeof gform !== 'undefined' &&
                // eslint-disable-next-line
                typeof gform.getNextPage === 'function'
              ) {
                // eslint-disable-next-line
                var nextPage = gform.getNextPage($form)
                if (nextPage > 0) {
                  // eslint-disable-next-line
                  gform.navigate($form, nextPage)
                  $('html, body').animate(
                    {
                      scrollTop: $form.offset().top - 20,
                    },
                    500
                  )
                }
              }
            },
          })
        }
      )
    })

    // fixed spam declined captcha.eu issue for multistep form
    jQuery(document).on('gform_post_render', function (
      event,
      form_id,
      current_page
    ) {
      if (form_id == 20 && current_page == 5) {
        // eslint-disable-next-line
        KROT.interceptForm(document.querySelector('#gform_20'))
      }
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
